<template>
  <div class="DarkWhite pa-4">
      <h2 class="subheading green--text">Budget Fund Source</h2>
      <v-card class="mt-4">
      <BudgetFundSource/>
  </v-card>
  </div>
</template>

<script>
import BudgetFundSource from '@/components/Utils/BudgetFundSource.vue'
  export default {
    components: {
      BudgetFundSource
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>
